import { Box, Typography } from '@mui/material';
import { t } from 'i18next';
import LogisDashboard from 'images/Logistics.png';
export default function LogisDetails() {
  return (
    <Box px={2} py={2}>
      <Typography variant='h5' align='center' mb={2}>{t('logisticdashboardText', { ns: ['home'] })}</Typography>
      <img src={LogisDashboard} style={{ width: '100vw' }} />
    </Box>
  );
}
